import React, { useState, useEffect } from "react";

import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import Select from "react-select";
import PermisosPorModulo from "./PermisosPorModulo";
const Autorizaciones = () => {
  const [perfilSeleccionado, setPerfilSeleccionado] = useState(null);
  const [moduloSeleccionado, setModuloSeleccionado] = useState(null);

  useEffect(() => {
    setPerfilSeleccionado({ value: "Choices 1", label: "Administrador" });
    setModuloSeleccionado({ value: "Choices 1", label: "Bodega" });
  }, []);

  const opcionesPerfil = [
    { value: "administrador", label: "Administrador" },
    { value: "Choices 2", label: "Supervisor" },
    { value: "Choices 3", label: "Vendedor" },
    { value: "Choices 4", label: "Cajero" },
  ];

  const opcionesModulos = [
    { value: "bodega", label: "Bodega" },
    { value: "caja", label: "Caja / Facturación" },
    { value: "Choices 3", label: "Configuración" },
    { value: "Choices 4", label: "Post Venta" },
    { value: "Choices 5", label: "Rent a car" },
  ];

  const handleSelectProfile = (opcion) => {
    setPerfilSeleccionado(opcion );
  };

  const handleSelectModule = (opcion) => {
    setModuloSeleccionado(opcion);
  };
  return (
    <Row>
      <Col lg={12}>
        <Card>
          <CardHeader>
            <Row>
              <h5 className="card-title mb-3">Autorizaciones</h5>
            </Row>
            <Row>
              <Col xxl={3} md={6}>
                <div className="mb-3">
                  <Select
                    id="perfil"
                    placeholder="Perfil..."
                    value={perfilSeleccionado}
                    onChange={(opcion) => {
                      handleSelectProfile(opcion);
                    }}
                    options={opcionesPerfil}
                  />
                </div>
              </Col>
              <Col xxl={3} md={6}>
                <div className="mb-3">
                  <Select
                    id="modulo"
                    placeholder="Módulo..."
                    value={moduloSeleccionado}
                    onChange={(opcion) => {
                      handleSelectModule(opcion);
                    }}
                    options={opcionesModulos}
                  />
                </div>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <PermisosPorModulo
              profileId={perfilSeleccionado?.value}
              submoduleId={moduloSeleccionado?.value}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default Autorizaciones;
